export default __webpack_public_path__ + "static/media/warning--height-restriction--g2.338e63be.png";